import { Select } from "antd";
import { useTranslation } from "react-i18next";

interface IProps {
  value?: number | null;
  onChange?: (value: number | null) => void;
  placeholder?: string;
}

const SelectYear = (props: IProps) => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: currentYear - 1900 + 1 }, (_, i) => {
    const year = currentYear - i;
    return { label: year.toString(), value: year };
  });

  return (
    <Select
      placeholder={props.placeholder || t("msg.selectPlaceholder")}
      value={props.value}
      onChange={props.onChange}
      options={yearOptions}
      showSearch
      allowClear
    />
  );
};

export default SelectYear;
